<template>
    <loader v-if="loading" />
    <div v-else>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="bar" :options="chart.options" :series="chart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs grow v-model="teamTab">
                        <v-tab>
                            Alle
                        </v-tab>
                        <v-tab v-for="team in teams" :key="team">
                            {{ team }}
                        </v-tab>
                    </v-tabs>
                    <v-card-text>
                        <v-subheader>
                            <v-col>
                                Navn
                            </v-col>
                            <v-col>
                                Status
                            </v-col>
                            <v-col>
                                Første opkald
                            </v-col>
                            <v-col>
                                Seneste opkald
                            </v-col>
                        </v-subheader>
                        <v-list class="striped-list">
                            <v-list-item v-for="agent in sortedAgents" :key="agent.name">
                                <v-col>
                                    {{ agent.name }}
                                </v-col>
                                <v-col>
                                    <v-chip v-if="agent.live" color="green">Live</v-chip>
                                    <v-chip v-else-if="agent.firstCall" color="yellow">Aktiv</v-chip>
                                    <v-chip v-else color="red">Inaktiv</v-chip>
                                </v-col>
                                <v-col>
                                    {{ formatTimestamp(agent.firstCall) }}
                                </v-col>
                                <v-col>
                                    {{ formatTimestamp(agent.lastCall) }}
                                </v-col>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment'
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
	},
    data () {
        return {
            loading: true,
            teams: [],
            teamTab: 0,
            agents: [],
            chart: {
                series: [],
                options: {
                    chart: {
                        stacked: true,
                        toolbar: {
                            show: false
                        }
                    },
                    xaxis: {
                        categories: []
                    },
                    legend: {
                        position: 'right'
                    },
                    colors: ['#4CAF50', '#FFEB3B', '#F44336']
                }
            }
        }
    },
    computed: {
        team () {
            if (this.teamTab === 0) return null
            else return this.teams[this.teamTab - 1]
        },
        filteredAgents () {
            return this.team ? this.agents.filter(agent => agent.team === this.team) : this.agents
        },
        sortedAgents () {
            const agents = this.filteredAgents
            return agents.sort((a, b) => {
                if (a.live && !b.live) return -1
                else if (!a.live && b.live) return 1
                else if (a.firstCall && !b.firstCall) return -1
                else if (!a.firstCall && b.firstCall) return 1
                const aMoment = moment(a.lastCall)
                const bMoment = moment(b.lastCall)
                if (aMoment.isValid()) {
                    if (bMoment.isValid()) return aMoment.isAfter(bMoment) ? -1 : 1
                    else return -1
                }
                else if (bMoment.isValid()) return 1
                else return -1
            })
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('/live', {
                params: {
                    date: moment().format('YYYY-MM-DD')
                }
            })
            this.teams = response.data.labels
            this.chart.options.xaxis.categories = response.data.labels
            this.agents = response.data.agents
            this.chart.series = response.data.series
            this.loading = false
        },
        formatTimestamp (date) {
            const dateMoment = moment(date)
            return dateMoment.isValid() ? dateMoment.format('hh:mm') : null
        }
    },
    created () {
        this.getData()
    }
}
</script>